import type { BackendRouteDefinition } from '../types';

export const approveDraftInvoiceRoute = {
  body: (request: {
    approvalKind: 'ordinary' | 'trust';
    attemptId: string;
    expectedDraftStateUpdatedTimestamp?: Date;
    expectedInvoiceNumber?: number;
    expenseEntryIds: string[];
    finalizedFields: Record<string, unknown>;
    matterId: string;
    presentationSnapshotData: Record<string, unknown>;
    timeEntryIds: string[];
  }) => request,
  method: 'POST',
  path: '/firms/invoice-approvals',
  transport: 'api',
} as const satisfies BackendRouteDefinition;

export const revertDraftInvoiceApprovalRoute = {
  body: (request: { expectedFinalizedTimestamp: Date; invoiceId: string }) => ({
    expectedFinalizedTimestamp: request.expectedFinalizedTimestamp,
  }),
  method: 'POST',
  params: (request: { invoiceId: string }) => ({
    invoiceId: request.invoiceId,
  }),
  path: '/firms/invoice-approvals/:invoiceId/revert',
  transport: 'api',
} as const satisfies BackendRouteDefinition;
